<template>
  <div class="grid grid-cols-2 gap-1.5 px-2 lg:gap-10">
    <template v-for="(item, index) in filteredBlok" :key="item._uid">
      <GoldnerClubLink
        v-if="showGoldnerClub && item.component === 'GoldnerClubLink'"
        class="!text-sm font-normal leading-4 text-black lg:text-black-80"
        data-test-id="goldner-club-link"
        @click:link="trackGoldnerClubClick"
      />
      <CMSLink
        v-else-if="item.component === 'TopMetaBarLabel'"
        :key="item._uid"
        class="text-sm font-normal leading-4 text-black lg:text-black-80"
        :cms-link="item.link"
        :open-new-tab="openNewTab(item)"
        data-test-id="top-meta-bar-link"
        @click="trackEvent(index)"
        >{{ item.label }}
      </CMSLink>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { PropType } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import type {
  SbGoldnerClubLink,
  SbNavigation,
  SbTopMetaBarLabel,
} from '~/cms/storyblok/types/storyblok.d.ts'
import GoldnerClubLink from '~/components/ui/GoldnerClubLink.vue'

type TopMetaBarItem = SbTopMetaBarLabel | SbGoldnerClubLink

const props = defineProps({
  blok: {
    type: Array as PropType<SbNavigation['TopMetaBar']>,
    default: () => [],
  },
})

const emit = defineEmits(['click:link'])
const { showGoldnerClub } = useExperiments()

const filteredBlok = computed<TopMetaBarItem[]>(
  () =>
    props.blok?.filter((item): item is TopMetaBarItem => {
      if (item.component === 'TopMetaBarLabel') {
        return !!item.link && !!item.label
      }
      if (item.component === 'GoldnerClubLink') {
        return item.visible !== false
      }
      return false
    }) ?? [],
)

const trackGoldnerClubClick = (link: string | RouteLocationRaw) => {
  emit('click:link', link)
}

const trackEvent = (index: number) => {
  const item = filteredBlok.value?.[index]

  if (!item || item.component !== 'TopMetaBarLabel') {
    return
  }

  emit('click:link', item?.link?.cached_url)
}

const openNewTab = (item: TopMetaBarItem) => {
  if (item.component !== 'TopMetaBarLabel') {
    return false
  }
  return (
    item.link?.cached_url?.startsWith('http://') ||
    item.link?.cached_url?.startsWith('https://')
  )
}
</script>
